import { render } from "./PropertyOverviewPage.vue?vue&type=template&id=3e0647a2&ts=true"
import script from "./PropertyOverviewPage.vue?vue&type=script&lang=ts"
export * from "./PropertyOverviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__